export default {
    initMessages: [{
            type: "text",
            author: `bot`,
            data: {
                text: `嗨～我是台北智慧城市的AI兔，在智慧台北玩得開心嗎？`
            }
        },
        {
            type: "text",
            author: `bot`,
            data: {
                text: `現在讓我幫你選出適合你的台北創新生活，只要回答幾個問題就可以囉！`
            }
        }
    ],
    questions: [{
            type: "text",
            author: `bot`,
            data: {
                text: `請問你的職業是什麼呢？`
            },
            suggestions: [
                "學生",
                "工業",
                "商業",
                "科技業",
                "軍公教",
                "農業",
                "服務業",
                "其他"
            ]
        },
        {
            type: "text",
            author: `bot`,
            data: {
                text: `悠閒的周末假日，你會如何安排呢？`
            },
            suggestions: [
                "宅在家哪也不去",
                "到百貨公司逛街購物",
                "到運動中心爆汗",
                "到咖啡廳靜靜看一本書",
                "看藝術展覽或表演提升氣質"
            ]
        },
        {
            type: "text",
            author: `bot`,
            data: {
                text: `你一般外出會選擇哪個方式前往？`
            },
            suggestions: [
                "公車或捷運",
                "自行車",
                "摩托車", 
                "開車", 
                "計程車"
            ]
        },
        {
            type: "text",
            author: `bot`,
            data: {
                text: `你會想要點哪一個美食呢?`
            },
            suggestions: [
                "大腸麵線",
                "滷味",
                "豬腳",
                "滷肉飯",
                "小籠包",
                "牛排"
            ]
        },
        {
            type: "text",
            author: `bot`,
            data: {
                text: `餐後應該要來個甜點，你想選？`
            },
            suggestions: [
                "抹茶蛋糕",
                "冰淇淋總匯",
                "豆花粉圓冰",
                "檸檬派"
            ]
        },
    ]
}